<template>
  <div class="map-area map_holder" v-show="value.length > 0">
    <div class="map" />
  </div>
</template>

<script>
import Vue from "vue";
import { get } from "vuex-pathify";
import gmapsInit from '@/utils/gmaps';
import mixins from "@/mixins";
import { Marker } from "@/components";

export default {
  name: "ParkingMap",
  mixins: [mixins.globals, mixins.format],
  props: {
    value: { type: Array, required: true, },
    more: { type: Boolean, default: false }
  },
  computed: {
    airport: get("results/airport"),
    showBook() {
      return this.$route.name !== 'payment'
    }
  },
  data() {
    return {
      map: false,
      markers: [],
      infoWindows: [],
      bounds: null,
    }
  },
  watch: {
    async value() {
      this.infoWindows = [];

      for (var i = 0; i < this.markers.length; i++ ) {
        this.markers[i].setMap(null);
      }

      this.markers.length = 0;

      if(this.value.length > 0) await this.markerFactory();
      
      if(this.map) {
        this.map.fitBounds(this.bounds, 0);
        this.map.setCenter(this.bounds.getCenter());
      }
    }
  },
  methods: {
    async markerFactory() {
      try {

        const google = await gmapsInit();
        this.bounds = new google.maps.LatLngBounds();
        let position = new google.maps.LatLng(parseFloat(this.airport.latitude),parseFloat(this.airport.longitude))
        
        this.bounds.extend(position);

        let airport = new google.maps.Marker({
          position,
          map: this.map,
          icon: `${this.cdn}/images/ico-plane-small.png`,
        });

        this.markers = this.value.map(x => {

          let product = x.product;
          let duplicateLocations = []

          // check for markers with the same lat/lng
          if(product.product_type == 'airportparking') {

            this.value.map( marker => {
              if(marker.product.latitude == product.latitude && marker.product.longitude == product.longitude) {
                duplicateLocations.push(marker)
              }
            })
          }

          let InfoWindow = Vue.extend(Marker);

          let instance = new InfoWindow({ 
            propsData: { 
              more: this.more,
              book: this.showBook,
              product,
              products: duplicateLocations,
              bookNowText: this.$t('airportparking.results.map.book_now'),
              moreInfoText: this.$t('airportparking.results.map.more_info'),
              currency: this.currency,
              airport: this.airport.airport_name
            } 
          });

          instance.$mount();

          let infowindow = new google.maps.InfoWindow({
            content: instance.$el,
          });

          this.infoWindows.push(infowindow);

          let location = {
            lat: product.product_type == 'airportparking' ? product.latitude : product.hotel_info.latitude,
            lng: product.product_type == 'airportparking' ? product.longitude : product.hotel_info.longitude
          }
          let position = new google.maps.LatLng(parseFloat(location.lat), parseFloat(location.lng))

          this.bounds.extend(position);

          let marker = new google.maps.Marker({
            position,
            map: this.map,
            icon: `${this.cdn}/images/ico-${product.product_type == 'airportparking' ? 'car-small' : 'hotel'}.png`
          });

          if(product.product_type == 'airportparking') {
            marker.addListener('click', () => {
              this.infoWindows.map(x => x.close())
              infowindow.open(this.map, marker);
            });
          }
          return marker
        });

        this.markers.push(airport)

      } catch (error) {
       throw error;
      }
    }
  },

  async mounted() {

    try {
      const google = await gmapsInit();
      const options = {
        zoom: 14,
        minZoom: 12,
        zoomControl: true,
        clickableIcons: false,
        scrollwheel: false,
        disableDefaultUI: true,
        navigationControl: true,
        mapTypeControl: false,
        scaleControl: true,
        center: { 
          lat: parseFloat(this.airport.latitude), 
          lng: parseFloat(this.airport.longitude) 
        }
      }
      this.map = new google.maps.Map(this.$el, options);

      await this.markerFactory();

      this.map.fitBounds(this.bounds, 0);
      this.map.setCenter(this.bounds.getCenter());

    } catch (error) {
      throw error;
    }
  }
};
</script>